export default {"src":"/_next/static/media/au.f7730bcd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};